import { render, staticRenderFns } from "./CVForm.vue?vue&type=template&id=5b56c5d9&"
import script from "./CVForm.vue?vue&type=script&lang=js&"
export * from "./CVForm.vue?vue&type=script&lang=js&"
import style0 from "./CVForm.vue?vue&type=style&index=0&id=5b56c5d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports